import React from 'react'
import { Text } from '@fundamentals'
import { TimelineBlockBase } from './TimelineBlockBase'
import { AuditResultMetadata } from '@core/entities/audit/AuditResult/AuditResultMetadata'

type TimelineCompanyBlockProps = {
  metadata: AuditResultMetadata
  title: string
  companyData: { name: string; code: string } | null
}

export const TimelineCompanyBlock: React.FC<TimelineCompanyBlockProps> = ({
  metadata,
  title,
  companyData,
}) => {
  if (!companyData) {
    return null
  }

  return (
    <TimelineBlockBase title={title}>
      <Text>{companyData.name}</Text>
      {companyData.code && (
        <Text color='text.secondary' fontSize={12}>
          {companyData.code}
        </Text>
      )}
    </TimelineBlockBase>
  )
}
